import App from './App'
import './index.css'
import React from 'react'
import ReactDOM from 'react-dom/client'
import GA4React, { useGA4React } from 'ga-4-react'
import { initTracing } from './tracing'

// Must run before the app makes its first request, otherwise those calls are
// not instrumented. No-ops unless REACT_APP_SIGNOZ_URL is set.
initTracing()

const root = ReactDOM.createRoot(document.getElementById('root'))

if (process.env.REACT_APP_GOOGLE_ANALYTICS_ID) {
  try {
    setTimeout((_) => {
      const ga4react = new GA4React(process.env.REACT_APP_GOOGLE_ANALYTICS_ID)
      ga4react.initialize().catch((err) => console.error(err))
    }, 40000)
  } catch (err) {
    console.error(err)
  }
}

root.render(<App />)
